import { render, staticRenderFns } from "./TabTwo.vue?vue&type=template&id=36b25603&scoped=true&"
import script from "./TabTwo.vue?vue&type=script&lang=js&"
export * from "./TabTwo.vue?vue&type=script&lang=js&"
import style0 from "./TabTwo.vue?vue&type=style&index=0&id=36b25603&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b25603",
  null
  
)

export default component.exports